import React from 'react';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import PropTypes from 'prop-types';

function BalanceButtonsGroup(props) {
  const {
    handleOpenForm,
    handleOpenModal,
    userCanAddFunds,
    balance,
    hasAdvancedAlerting,
  } = props;
  return (
    <span>
      <span className="form-check-label">Balance-to-date:</span>
      <span className="badge alert-info text-dark mx-2">
        $
        {balance}
      </span>
      <button
        type="button"
        className="btn btn-sm btn-link"
        onClick={handleOpenForm}
        disabled={!userCanAddFunds || !hasAdvancedAlerting}
      >
        <Icon icon="plus" />
        {' '}
        Add Funds
      </button>
      <button
        type="button"
        className="btn btn-sm btn-link"
        onClick={handleOpenModal}
      >
        <Icon icon="info-circle" />
        {' '}
        Current SMS Pricing
      </button>
    </span>
  );
}

BalanceButtonsGroup.propTypes = {
  handleOpenForm: PropTypes.func.isRequired,
  handleOpenModal: PropTypes.func.isRequired,
  userCanAddFunds: PropTypes.bool.isRequired,
  hasAdvancedAlerting: PropTypes.bool.isRequired,
  balance: PropTypes.string.isRequired,
};

export default BalanceButtonsGroup;
